import React from 'react';
import Carousel from 'nuka-carousel';
import Bullets from '../slider/bullets.component.js';
import '../slider/bulllets.scss';
import './physical-installation-slider.scss';

class PhysicalInstallationSlider extends React.Component {
	constructor(props) {
		super(props);
		this.carouselRef = React.createRef();
	}

	handleSlide = index => {
		if (this.carouselRef) {
			this.carouselRef.current.goToSlide(index);
		}
	};

	render() {
		const { category } = this.props;
		return (
			<div className="container col-xs-12 col-md-11 item center-xs start-md">
				<div className="row">
					<div className="text-container col-xs-12 col-md-12">
						<div className="title-label titleslide">
							<p className="titlep">
								{category && category.value && category.value.categoryname}
							</p>
						</div>
					</div>
					<div className="text-container col-xs-12 col-md-12">
						<div className="description sliderDescription">
							<p className="sliderp">
								{category &&
									category.value &&
									category.value.categorydescription}
							</p>
						</div>
					</div>
					<div className="slider-container">
						<Carousel
							ref={this.carouselRef}
							wrapAround
							renderCenterLeftControls={({ previousSlide }) => (
								<button className="left-arrow" onClick={previousSlide} />
							)}
							renderCenterRightControls={({ nextSlide }) => (
								<button className="right-arrow" onClick={nextSlide} />
							)}
							defaultControlsConfig={{
								pagingDotsStyle: {
									fill: 'rgba(140,159,175,0.2)'
								}
							}}
							renderBottomCenterControls={() => (
								<Bullets
									amount={category && category.value.categoryslide.length}
									selected={
										this.carouselRef.current
											? this.carouselRef.current.state.currentSlide
											: null
									}
									handleToSlide={this.handleSlide}
								/>
							)}
						>
							{category &&
								category.value.categoryslide.map(images => (
									<div key={images.value.path} className="image-container">
										<img
											src={
												process.env.REACT_APP_API_ENDPOINT + images.value.path
											}
											alt="imgslide1"
										/>
										<div className="shadow-gradient" />
									</div>
								))}
						</Carousel>
					</div>
				</div>
			</div>
		);
	}
}

export default PhysicalInstallationSlider;
